import { c as _c } from "react/compiler-runtime";
import { IcoCloseSmall16 } from '@onefootprint/icons';
type ClearButtonProps = {
  'aria-label': string;
  isVisible: boolean;
  onClick: () => void;
};
const ClearButton = t0 => {
  const $ = _c(5);
  const {
    "aria-label": ariaLabel,
    isVisible,
    onClick
  } = t0;
  const t1 = !isVisible;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <IcoCloseSmall16 />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== ariaLabel || $[2] !== onClick || $[3] !== t1) {
    t3 = <button type="button" onClick={onClick} aria-label={ariaLabel} hidden={t1} className="absolute right-2 top-1/2 -translate-y-1/2 flex items-center p-0 border-none outline-none cursor-pointer bg-primary transition-opacity duration-200 hover:opacity-70">{t2}</button>;
    $[1] = ariaLabel;
    $[2] = onClick;
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
export default ClearButton;